import ClientTypeOptInState from 'owa-service/lib/contract/ClientTypeOptInState';
import { getCookie, updateCookie } from './browserCookieWrapper';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export const OPT_IN_COOKIE_NAME: string = 'OptInPrg';

export function isClientOptingReact(): boolean {
    return isClientOpting(ClientTypeOptInState.React);
}

export function isClientOptingJsmvvm(): boolean {
    return isClientOpting(ClientTypeOptInState.Jsmvvm);
}

function isClientOpting(client: ClientTypeOptInState): boolean {
    const optinCookieValue = getCookie(OPT_IN_COOKIE_NAME);
    return optinCookieValue == '' + client;
}

export function optIntoJsmvvmClient() {
    updateClientOptInStateCookie(ClientTypeOptInState.Jsmvvm);
}

export function optIntoJsmvvmClientAndRedirect(modulePath?: string) {
    optIntoJsmvvmClient();

    const sessionType = getUserConfiguration().SessionSettings.WebSessionType;
    let redirectPath = '/owa/';
    const params = [];
    if (sessionType) {
        params.push('isc=' + sessionType);
    }

    if (modulePath) {
        params.push(modulePath);
    }

    if (params.length > 0) {
        redirectPath = redirectPath + '?' + params.join('&');
    }

    location.assign(redirectPath);
}

export function updateClientOptInStateCookie(value: ClientTypeOptInState) {
    if (value == null) {
        updateCookie(OPT_IN_COOKIE_NAME);
    } else {
        updateCookie(OPT_IN_COOKIE_NAME, '' + value, { path: '/' });
    }
}
